module.exports = "/cabinet/img/esia.f821b6b6.svg";